import './clientEntry';
import './initializeI18n';

import {
  buildClientApp,
  generateCarleadCreationConfig,
} from '@retail/funnel-components';
import { initRUM, patchRoutesWithRUM } from '@retail/funnel-rum';
import pckJson from '../package.json';
import clientRoutes from './clientRoutes';
import { funnelOptions } from './funnelOptions';

const appConfig = generateCarleadCreationConfig(
  'nl-BE',
  pckJson,
  funnelOptions,
);

initRUM(appConfig);

buildClientApp(appConfig, patchRoutesWithRUM(clientRoutes));
